import React from 'react';
import { Trash2 } from 'lucide-react';
import { CostLineItem } from '../../types/billing';

interface CostLineItemRowProps {
  item: CostLineItem;
  readOnly?: boolean;
  onRemove?: (itemId: string) => void;
}

export const CostLineItemRow: React.FC<CostLineItemRowProps> = ({ item, readOnly = false, onRemove }) => {
  return (
    <div className="flex items-center gap-2 py-2 px-3 bg-slate-950 rounded-lg border border-slate-800 text-xs">
      <div className="flex-1 min-w-0">
        <p className="text-slate-200 font-medium truncate">{item.description}</p>
        <p className="text-slate-500 mt-0.5">
          {item.quantity} {item.unit} × Rs {item.unit_price.toLocaleString()}
        </p>
      </div>
      <span className="text-slate-300 font-semibold whitespace-nowrap">
        Rs {item.amount.toLocaleString()}
      </span>
      {!readOnly && onRemove && (
        <button
          onClick={() => onRemove(item.item_id)}
          className="p-1 text-slate-500 hover:text-rose-400 hover:bg-rose-500/10 rounded transition-colors"
        >
          <Trash2 className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
};
